import Helper from '@/utils/helper'
import { layouts } from '@/app/const/settings'

class Layout {
  constructor ({ code }) {
    this.code = Helper.getValue(code, layouts.default)
  }

  getCode () {
    return this.code
  }
}

export default Layout
